import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';

const SuccessModal = ({ open, onClose }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle sx={{ textAlign: 'center', color: 'error.main' }}>
                <CheckCircleIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
                <Typography variant="h5" color="error" component="div">
                    Upload Successful!
                </Typography>
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center', pb: 2 }}>
                <Typography variant="body1" color="text.secondary" paragraph>
                    Your transliteration file has been uploaded successfully and is being processed.
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    You will be notified once the transliteration process is complete.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
                <Button
                    onClick={onClose}
                    variant="contained"
                    color="error"
                    size="large"
                    sx={{ minWidth: 120 }}
                >
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SuccessModal;